import classNames from 'classnames';
import React, { DetailedHTMLProps, HTMLAttributes, Component, PropsWithChildren, ReactElement } from 'react';
import { ITableRowProps, TableCellDataDefinition, TableCellDataTypes } from './types';

export class TableRow extends Component<PropsWithChildren<ITableRowProps>, {}> {
  public render() {
    const rowClasses = classNames({
      active: this.props.active,
      danger: this.props.danger,
      info: this.props.info,
      success: this.props.success,
      warning: this.props.warning,
    });

    const props: DetailedHTMLProps<HTMLAttributes<HTMLTableRowElement>, HTMLTableRowElement> = {
      className: rowClasses,
    };

    if (typeof this.props.onClick === 'function') {
      props.onClick = this.props.onClick;
    }

    return <tr {...props}>{this.props.data.map((item, index) => this.renderTableCell(item, index))}</tr>;
  }

  public renderTableCell(item: TableCellDataDefinition, index: number) {
    let cellType = 'td';

    const cellObj =
      typeof item === 'object' && item !== null && !React.isValidElement(item)
        ? (item as { heading?: boolean; datum: TableCellDataTypes })
        : null;

    const declaredItemType = cellObj?.heading;

    if (declaredItemType === true || this.props.heading) {
      cellType = 'th';
    }

    let children: TableCellDataDefinition = item;

    if (cellObj && Object.prototype.hasOwnProperty.call(cellObj, 'datum')) {
      children = cellObj.datum;
    }

    return React.createElement(cellType, { key: index, className: 'hl-table-td' }, children as unknown as ReactElement);
  }
}

export default TableRow;
